import axios from '../library/axiosConfig';
export  default {
  upyunGeneToken (data) {
    return axios.post('/upyun/geneToken', data, {baseURL: axios.defaults.commbiz})
  }
}



// WEBPACK FOOTER //
// ./src/api/commbiz.js